<ng-container *ngIf="conversationHeads$ | async as messages">
	<mat-card
		*ngFor="let message of messages"
		class="message-card branding--list-item-card"
		[ngClass]="{ 'message-card-unread': !message.isRead, 'selected': message?.id === markMessageIdAsSelected }"
		>
		<mat-card-content (click)="messageClicked(message)">
			<div class="card-grid">
				<div mat-card-avatar class="message-avatar" [ngStyle]="message | avatarColours">
					<div class="message-avatar-text" [innerHTML]="message | avatarText"></div>
				</div>
				<app-order-id-chip class="order-id-chip" [orderID]="message.orderId" [description]="message.campaignName" [messageID]="message.id"></app-order-id-chip>
				<div class="timestamp">
					{{ message.timestamp | cassTimestamp }}
				</div>
				<div class="message-block">
					<span class="message-sender">
						{{
							(message.senderUserName ?? ("SYS_NOTIFICATIONS.UNKNOWN_SENDER_LABEL" | translate))
							+ (message.senderCompanyId ? " (" + getCompanyNameById(message.senderCompanyId) + ")" : "")
							+ ": "
						}}
					</span>
					<span class="message-text">{{ message.messageText }}</span>
				</div>
				<div class="selection-mark" *ngIf="message.id === markMessageIdAsSelected">
					<mat-icon>chevron_right</mat-icon>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
	<mat-card class="no-items" *ngIf="messages.length === 0">
		<mat-card-header>
			<mat-chip-set>
				<mat-basic-chip>{{ (showUnreadOnly ? "CHAT_MESSAGES.MESSAGES_PAGE.NO_NEW_MESSAGES_ALERT" : "CHAT_MESSAGES.MESSAGES_PAGE.NO_MESSAGES_ALERT") | translate }}</mat-basic-chip>
			</mat-chip-set>
		</mat-card-header>
	</mat-card>
</ng-container>
<ng-container *ngIf="!(callingOut$ | async); else loading">
</ng-container>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>
